export function headerAppToken(token: string, contentType="application/json"){
  return {
      'Content-Type': contentType,
      'X-ILY-API-appKey': process.env.REACT_APP_HEADER_APPKEY as string,
      'X-ILY-API-appToken': `Bearer ${token}`
    }
}

